"use strict";

(function(){

var self = Fotobook.productRegions = {
    regions: {},
    set: function(data){
        this.regions = {};
        data.forEach(function(region){
            self.regions[region.region_type] = region;
        });
    },
    getByCode: function(type){
        return this.regions[type];
    },
};

$(document)
.on(Fotobook.events.AJAX_DONE, function(event, result, response){
    if (response && response.data && response.data.productRegions){
        self.set(response.data.productRegions);
    }
})
.on(Fotobook.events.ONLINE_EDITOR_INIT_DATA, function(event, initData){
    self.set(initData.productRegions);
})
;



})();
